import React from 'react'

import Styles from "./adminActus.module.scss";
import IActualite from 'model/actualite';
import ActualitesService from 'services/actualitesService';
import { Table, Button, Input, Form, FormGroup, Label, Container } from 'reactstrap';
import DateTimePicker from 'react-datetime-picker'
import confirm from 'reactstrap-confirm';
import { isPicture } from 'components/common/fileExplorer/fileExplorer';
import FileFolderSelector from 'components/common/fileFolderSelector/fileFolderSelector';
import Editor from 'components/common/editor/editor';
interface IAdminActusProps {

}

interface IAdminActusState {
    actuEdition?: IActualite;
    actus: IActualite[];
}

class AdminActus extends React.Component<IAdminActusProps, IAdminActusState> {
    /**
     *
     */
    constructor(props: IAdminActusProps) {
        super(props);

        this.state = { actuEdition: undefined, actus: [] };
    }


    componentDidMount() {
        this.load();
    }

    load() {
        ActualitesService.GetAllActus().then(actus => {
            this.setState({ actus: actus.sort((a: IActualite, b: IActualite) => { return a.Id < b.Id ? -1 : 1 }), actuEdition: undefined });
        })
    }

    setActuToEdit(actu: IActualite) {
        this.setState({ actuEdition: actu });
    }

    saveActu(actu: IActualite) {
        ActualitesService.SetActu(actu).then(this.load.bind(this));
    }


    setActuToDelete(actu: IActualite) {
        confirm({
            title: 'Suppression de l\'actualité',
            message: "Etes vous sûr de vouloir supprimer l'actualité ?",
            confirmText: "Supprimer",
            confirmColor: "primary",
            cancelColor: "danger"
        }).then((res: any) => {
            if (res) {
                return ActualitesService.DeleteActu(actu).then(this.load.bind(this));
            }
        });
    }

    render() {
        return <div className={Styles.AdminActus}>
            <Container>

                <Button color="primary" onClick={this.setActuToEdit.bind(this, { Content: '', Chapo: '', Title: '', Id: 0, IsALaUne: false, IsEvent: false, StartDate: undefined, EndDate: undefined, PublicationDate: new Date(Date.now()), PictureUrl: '' } as IActualite)}>Créer une actualité</Button>
                <Table>
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Titre</th>
                            <th>Date de publication</th>
                            <th>A la une ?</th>
                            <th>Editer</th>
                            <th>Supprimer</th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.state.actus.map(a => {
                            return <tr key={a.Id} className={Styles.ActuRow}>
                                <th scope="row">{a.Id}</th>
                                <td>{a.Title}</td>
                                <td>{a.PublicationDate.toDateString()}</td>
                                <td>{a.IsALaUne ? 'Oui' : 'Non'}</td>
                                <td><Button color="primary" onClick={this.setActuToEdit.bind(this, a)}>Editer</Button></td>
                                <td><Button color="danger" onClick={this.setActuToDelete.bind(this, a)}>Supprimer</Button></td>
                            </tr>
                        })}
                    </tbody>

                </Table>
                {this.state.actuEdition ?

                    <div className={Styles.Edition}>
                        {this.state.actuEdition.Id ? <h2>Edition de l'actualité {this.state.actuEdition.Id}</h2> : <h2>Création d'actualité</h2>}
                        <Form>
                            <FormGroup>
                                <Label for="inputTitle">Titre</Label>
                                <Input id="inputTitle" placeholder="Titre" value={this.state.actuEdition.Title} onChange={(newText) => {
                                    if (this.state.actuEdition)
                                        this.setState({ actuEdition: { ...this.state.actuEdition, Title: newText.target.value } })
                                }} />
                            </FormGroup>
                            <FormGroup>
                                <Label for="inputChapo">Chapô</Label>
                                <Input placeholder="Chapô" value={this.state.actuEdition.Chapo} onChange={(newText) => {
                                    if (this.state.actuEdition)
                                        this.setState({ actuEdition: { ...this.state.actuEdition, Chapo: newText.target.value } })
                                }} />
                            </FormGroup>
                            <FormGroup>
                                <Label for="inputContent">Contenu</Label>
                                <Editor onChange={(newText) => {
                                    if (this.state.actuEdition)
                                        this.setState({ actuEdition: { ...this.state.actuEdition, Content: newText.target.getContentAreaContainer().innerHTML } })
                                }} initialValue={this.state.actuEdition.Content} />

                            </FormGroup>
                            <FormGroup>
                                <Label for="inputPictureUrl">Image principale</Label>
                                <FileFolderSelector filter={isPicture} onSelect={this.saveChangeMainPicture.bind(this)} value={this.state.actuEdition.PictureUrl} />

                            </FormGroup>
                            <FormGroup>
                                <Label for="inputPublicationDate">Date de publication</Label>
                                <Input id="inputPublicationDate" type="date" value={this.dateToYMD(this.state.actuEdition.PublicationDate)} onChange={(newText) => {
                                    if (this.state.actuEdition)
                                        this.setState({ actuEdition: { ...this.state.actuEdition, PublicationDate: new Date(Date.parse(newText.target.value)) } })
                                }} />
                            </FormGroup>
                            <FormGroup check>
                                <Label for="cbIsALaUne" check><Input id="cbIsALaUne" type="checkbox" checked={this.state.actuEdition.IsALaUne} onChange={(newText) => {
                                    if (this.state.actuEdition)
                                        this.setState({ actuEdition: { ...this.state.actuEdition, IsALaUne: newText.target.checked } })
                                }} />{' '}
                                    Mettre à la une</Label>

                            </FormGroup>
                            <FormGroup check>
                                <Label for="cbIsEvent" check>
                                    <Input id="cbIsEvent" type="checkbox" checked={this.state.actuEdition.IsEvent} onChange={(newText) => {
                                        if (this.state.actuEdition)
                                            this.setState({ actuEdition: { ...this.state.actuEdition, IsEvent: newText.target.checked } })
                                    }} />{' '}Evenement ?
                                </Label>

                            </FormGroup>
                            {this.state.actuEdition.IsEvent ?
                                <FormGroup>
                                    <Label for="inputStartDate">Date de début</Label>{' '}
                                    <DateTimePicker value={this.state.actuEdition.StartDate} onChange={(newText: any) => {
                                        if (this.state.actuEdition)
                                            this.setState({ actuEdition: { ...this.state.actuEdition, StartDate: newText } })
                                    }} />
                                </FormGroup>

                                : null}
                            {this.state.actuEdition.IsEvent ?
                                <FormGroup>
                                    <Label for="inputEndDate">Date de fin</Label>{' '}
                                    <DateTimePicker value={this.state.actuEdition.EndDate} onChange={(newText: any) => {
                                        if (this.state.actuEdition)
                                            this.setState({ actuEdition: { ...this.state.actuEdition, EndDate: newText } })
                                    }} />
                                </FormGroup>

                                : null}
                        </Form>
                        <Button color="primary" onClick={this.saveActu.bind(this, this.state.actuEdition)}>Sauvegarder</Button>
                        <Button color="danger" onClick={() => this.setState({ actuEdition: undefined })}>Annuler</Button>
                    </div>
                    : null
                }
            </Container>
        </div>
    }
    dateToYMD(date: Date) {
        if (!date)
            return undefined;
        var d = date.getDate();
        var m = date.getMonth() + 1; //Month from 0 to 11
        var y = date.getFullYear();
        return '' + y + '-' + (m <= 9 ? '0' + m : m) + '-' + (d <= 9 ? '0' + d : d);
    }

    saveChangeMainPicture(value: string) {
        if (this.state.actuEdition)
            this.setState({ actuEdition: { ...this.state.actuEdition, PictureUrl: value } });
    }
}

export default AdminActus;